import Swiper from "swiper/bundle";

const HowItWorksSlider = () => {
  const sliderWrapper = document.querySelector(".how-it-works__slider-wrapper");

  if (sliderWrapper) {
    const smallSlider = sliderWrapper.querySelector(".how-it-works__slider-small");
    const bigSlider = sliderWrapper.querySelector(".how-it-works__slider-big");

    // Desktop/tablet btns
    const prevBtn = sliderWrapper.querySelector(".how-it-works__slider-btns .how-it-works__slider-button-prev");
    const nextBtn = sliderWrapper.querySelector(".how-it-works__slider-btns .how-it-works__slider-button-next");

    const prevBtnText = sliderWrapper.querySelector(".how-it-works__slider-button-prev span");
    const nextBtnText = sliderWrapper.querySelector(".how-it-works__slider-button-next span");
  
    // Mobile bnts
    const mobilePrevBtn = document.querySelector(".how-it-works__slider-btns-mobile .how-it-works__slider-button-prev");
    const mobileNextBtn = document.querySelector(".how-it-works__slider-btns-mobile .how-it-works__slider-button-next");

    const mobilePrevBtnText = document.querySelector(".how-it-works__slider-btns-mobile .how-it-works__slider-button-prev span");
    const mobileNextBtnText = document.querySelector(".how-it-works__slider-btns-mobile .how-it-works__slider-button-next span");

    function updateNavigationButtonsText(carousel) {
      if (!carousel || !carousel.slides || carousel.slides.length === 0) return;

      const totalSlides = carousel.slides.length;
      const currentIndex = carousel.realIndex;

      const prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      const nextIndex = (currentIndex + 1) % totalSlides;

      const prevSlideTitle = carousel.slides[prevIndex].querySelector(".title--03");
      const nextSlideTitle = carousel.slides[nextIndex].querySelector(".title--03");

      // Desktop/tablet btns
      prevBtnText.textContent = prevSlideTitle ? `${prevSlideTitle.textContent}` : "Previous";
      nextBtnText.textContent = nextSlideTitle ? `${nextSlideTitle.textContent}` : "Next";

      // Mobile bnts
      mobilePrevBtnText.textContent = prevSlideTitle ? `${prevSlideTitle.textContent}` : "Previous";
      mobileNextBtnText.textContent = nextSlideTitle ? `${nextSlideTitle.textContent}` : "Next";
    }

    // Function to duplicate slides if there are fewer than 3
    function duplicateSlidesIfNeeded(carousel) {
      const slidesCount = carousel.slides.length;
      if (slidesCount > 1 && slidesCount < 3 && window.innerWidth >= 768) {
        const slidesToAdd = slidesCount; 

        for (let i = 0; i < slidesToAdd; i++) {
          const slideClone = carousel.slides[i % slidesCount].cloneNode(true);
          carousel.wrapperEl.appendChild(slideClone);
        }
        carousel.update();
      }
    }

    if (smallSlider && bigSlider) {
      const smallCarousel = new Swiper(smallSlider, {
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        on: {
          init: function () {
            duplicateSlidesIfNeeded(this);
            updateNavigationButtonsText(this); 
          },
          slideChange: function () {
            updateNavigationButtonsText(this); 
          },
        },
      });

      const bigCarousel = new Swiper(bigSlider, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        thumbs: {
          swiper: smallCarousel,
        },
        navigation: {
          nextEl: window.innerWidth < 768 ? mobileNextBtn : nextBtn,
          prevEl: window.innerWidth < 768 ? mobilePrevBtn : prevBtn,
        },
        on: {
          init: function () {
            if (this.slides.length === 3) {
              this.slideTo(1);
            } 
            if (this.slides.length < 3) {
              prevBtn.classList.add("d-none");
              mobilePrevBtn.classList.add("d-none");
              this.update();  
            } else {
              prevBtn.classList.remove("d-none");
              mobilePrevBtn.classList.remove("d-none");
              this.update();  
            }
            duplicateSlidesIfNeeded(this);
          },
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
          1441: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
        },
      });

      bigSlider.addEventListener("click", (event) => {
        const clickedSlide = event.target.closest(".swiper-slide");
      
        if (clickedSlide && !clickedSlide.classList.contains("swiper-slide-active")) {
          const realIndex = bigCarousel.slides[bigCarousel.clickedIndex].getAttribute("data-swiper-slide-index");
          bigCarousel.slideToLoop(Number(realIndex));
        }
      });

      const updateNavigationOnResize = () => {
        const isMobile = window.innerWidth < 768;

        bigCarousel.params.navigation.nextEl = isMobile ? mobileNextBtn : nextBtn;
        bigCarousel.params.navigation.prevEl = isMobile ? mobilePrevBtn : prevBtn;

        bigCarousel.navigation.destroy();
        bigCarousel.navigation.init();    
        bigCarousel.navigation.update(); 
      };

      window.addEventListener("resize", updateNavigationOnResize);
    }
  }
};

export default HowItWorksSlider;

